import React from "react";
// import webmFile from "../../../public/static/webm/app-loading.webm";
import webmFile from "@myjourney-assets/webm/app-loading.webm";
import Lottie from "react-lottie";
// import animationData from "../../../public/static/animations/app-animations.json";
import animationData from "@myjourney-assets/animations/app-animations.json";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles({
  loadingContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    zIndex: 3000,
    backgroundColor: "#f0f0f0",
  },
});

const LottieAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <Lottie options={defaultOptions} height={90} width={230} />;
};
const AppLoading = () => {
  const classes = useStyles();

  return (
    <div className={classes.loadingContainer}>
      {/* <video width="150" loop autoPlay muted>
        <source src={webmFile} type="video/webm" />
      </video> */}
      <LottieAnimation />
    </div>
  );
};

export default AppLoading;
